export default function Footer({ info }) {
  return (
    <footer className="footer">
      <div className="footer-ornament">
        <div className="line" />
        <div className="diamond" />
        <div className="diamond" />
        <div className="diamond" />
        <div className="line" />
      </div>
      <div className="footer-top">
        <div className="footer-brand">
          <p className="footer-logo">NİŞANTAŞI</p>
          <p className="footer-tagline">Erkek Kuaför Salonu</p>
          <p className="footer-motto">&ldquo; Stilinizi yeniden tasarlıyoruz &rdquo;</p>
        </div>
        <div className="footer-socials">
          <a href={info?.instagram || '#'} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="2" y="2" width="20" height="20" rx="5" />
              <circle cx="12" cy="12" r="5" />
              <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
            </svg>
          </a>
          <a href={info?.tiktok || '#'} aria-label="TikTok" target="_blank" rel="noopener noreferrer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.87a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.3z" />
            </svg>
          </a>
          <a href={info?.facebook || '#'} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
            </svg>
          </a>
        </div>
      </div>
      <div className="footer-divider" />
      <p className="footer-copy">&copy; 2026 Nişantaşı Erkek Kuaför Salonu. Tüm hakları saklıdır.</p>
    </footer>
  );
}
